import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useDispatch, useSelector } from 'react-redux';
import ChatContainer from './ChatContainer/ChatContainer';
import ChatHeader from './ChatHeader/ChatHeader';
import ChatMessages, { isMobile } from './ChatMessages/ChatMessages';
import ConversationContainer from './ConversationContainer/ConversationContainer';
import ModalUsersConversation from './ModalUserList/ModalUserList';
import ButtonCircleAdd from '../Button/ButtonCircleAdd';
import ContactList from './ListContacts/ContactList';
import ChatFooter from './ChatFooter/ChatFooter';
import ChatInput from './ChatInput/ChatInput';
import * as ChatActions from '../../core/chat/action';
import DefaultAvatarImg from '../../assets/svg/avatar-default.svg';
import SendMessageButton from './SendMessageButton/SendMessageButton';
import './Messenger.scss';
import InstructionsText from './InstructionsText/InstructionsText';

function Messenger({
  username,
  messages,
  conversations,
  contacts,
  onCreate,
  addContact,
  activeUserConversation,
  onChangeConversation,
}) {
  const [inputValue, setInputValue] = useState('');
  const [open, setOpen] = useState(false);
  const { messageList } = useSelector((store) => store.chat);
  const dispatch = useDispatch();

  const onHandlerInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const onSendMessage = (e, button) => {
    if (button && inputValue.trim() !== '') {
      const { cognito_id: cognitoId } = activeUserConversation;
      onCreate({ content: inputValue, sendTo: cognitoId });
      setInputValue('');
    } else if (e?.key === 'Enter' && inputValue.trim() !== '') {
      const { cognito_id: cognitoId } = activeUserConversation;
      onCreate({ content: inputValue, sendTo: cognitoId });
      setInputValue('');
    }
  };

  const onOpenModalUsers = () => {
    setOpen(true);
  };

  const onCloseModalUsers = (user) => {
    setOpen(false);
    addContact(user);
  };

  const goToContacts = () => {
    dispatch(ChatActions.onResetUserConversation());
  };

  // load conversation users list
  useEffect(() => {
    if (messages) dispatch(ChatActions.onLoadUserConversationList(messages, username, contacts));
  }, [contacts, dispatch, messages, username]);

  // load messages by user active in conversation
  useEffect(() => {
    if (messages && activeUserConversation)
      dispatch(ChatActions.onLoadMessageList(messages, username, activeUserConversation));
  }, [activeUserConversation, contacts, dispatch, messages, username]);

  return (
    <div className="app">
      {activeUserConversation && (
        <div className="header-chat">
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/no-static-element-interactions */}
          <span style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => goToContacts()}>
            <KeyboardBackspaceIcon color="info" />
          </span>
          <img className="user-profile" src={DefaultAvatarImg} alt="" />
          <p>{`${activeUserConversation.name} ${activeUserConversation.last_name}`}</p>
        </div>
      )}
      <div className="wrapper">
        {!activeUserConversation && (
          <ConversationContainer>
            <ContactList contacts={conversations} onChangeConversation={onChangeConversation} />
            {isMobile() && conversations.length === 0 && <InstructionsText />}
            <ButtonCircleAdd onClick={onOpenModalUsers} />
          </ConversationContainer>
        )}

        <ChatContainer>
          <ChatHeader />
          <ChatMessages
            messages={messageList}
            isActive={activeUserConversation}
            onOpenModalUsers={onOpenModalUsers}
          />
          {activeUserConversation && (
            <ChatFooter>
              <ChatInput
                value={inputValue}
                onChange={onHandlerInputChange}
                onKeyDown={onSendMessage}
              />
              <SendMessageButton color="#0997BA" onClick={() => onSendMessage(null, true)} />
            </ChatFooter>
          )}
        </ChatContainer>
      </div>
      <ModalUsersConversation open={open} onClose={onCloseModalUsers} users={contacts} />
    </div>
  );
}

Messenger.defaultProps = {
  activeUserConversation: undefined,
};

Messenger.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  messages: PropTypes.arrayOf(PropTypes.any).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  contacts: PropTypes.arrayOf(PropTypes.any).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  conversations: PropTypes.arrayOf(PropTypes.any).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  activeUserConversation: PropTypes.object,
  onCreate: PropTypes.func.isRequired,
  addContact: PropTypes.func.isRequired,
  onChangeConversation: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
};

export default Messenger;
